import React from 'react';
import Styled from 'styled-components';
import PropTypes from 'prop-types';
import ErrorMessage from '../../atoms/ErrorMessage/ErrorMessage';
import { flexItemPadding } from './RefinancingForm.style';

export const ErrorContainer = Styled.div`
  padding: ${flexItemPadding};
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
   margin: 0;
  }
`;
const Error = ({ message }) => (
  <ErrorContainer>
    <ErrorMessage>
      <p>
        <strong>Achtung: </strong>
        {message}
      </p>
    </ErrorMessage>
  </ErrorContainer>
);

Error.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Error;
